import { render, staticRenderFns } from "./adminClassCard.vue?vue&type=template&id=637f100d&"
import script from "./adminClassCard.vue?vue&type=script&lang=js&"
export * from "./adminClassCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-cli-plugin-import-components */
const vueCliInstallComponent = require("!../../../node_modules/vue-cli-plugin-import-components/dist/runtime/installComponents.js")
import ActionHeader from "@/components/ActionHeader.vue";
import ConfirmModal from "@/components/confirmModal.vue";
import KeyValue from "@/components/keyValue.vue";
import TextInput from "@/components/textInput.vue";
vueCliInstallComponent(component, {ActionHeader, ConfirmModal, KeyValue, TextInput});